/**
 * TinyStatStrip —— 頁面頂端的「一排小數字」。
 *
 * 取代各頁自己刻的一張大 Card 包 3~4 張漸層 KPI 小 Card（每張約 100px 高、
 * 外面還套一層 20px padding 的殼，光統計就吃掉 140px）。Brad 2026-09-10：
 *   「不用移除，可以縮小一點，反正不要佔這麼高的 height 就好。」
 *
 * 所以這裡刻意做成**橫向**：icon ／ 數字 ／ 標籤 排成一列，整條約 44px。
 * 數字仍然是視覺重心（1.25rem、700），只是不再各自佔一個垂直區塊。
 *
 * ⚠️ `color` 要傳「R, G, B」字串（例如 '17, 205, 239'）不是 hex ——
 *    底色與邊框是用同一個色相不同 alpha 疊出來的，需要拆得開的格式。
 *
 * `extra` 放在最後面，給「不是數字但同一排」的東西用
 *（例如俱樂部管理的 Tax & Rebate 設定入口鈕）。
 */
import React from "react";

const TinyStatStrip = ({ items = [], extra = null, style = {} }) => (
  <div style={{
    display: 'flex', alignItems: 'stretch', flexWrap: 'wrap', gap: 10,
    marginBottom: 18, ...style,
  }}>
    {items.map((s, i) => (
      <div key={s.label || i} style={{
        flex: '1 1 150px', minWidth: 130,
        display: 'flex', alignItems: 'center', gap: 10,
        background: `linear-gradient(135deg, rgba(${s.color}, 0.15), rgba(${s.color}, 0.05))`,
        border: `1px solid rgba(${s.color}, 0.25)`,
        borderRadius: 8, padding: '9px 14px',
      }}>
        {s.icon && (
          <i className={`fa ${s.icon}`}
             style={{ color: s.iconColor || `rgb(${s.color})`, fontSize: '1.15rem', opacity: 0.9 }} />
        )}
        <div style={{ lineHeight: 1.2, minWidth: 0 }}>
          {/* `valueStyle` 給「值不是短數字」的情況用（例如週期字串要小一點才放得下） */}
          <div style={{ fontWeight: 700, fontSize: '1.25rem', color: 'rgba(255,255,255,0.95)', ...(s.valueStyle || {}) }}>
            {s.value}
          </div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)' }}>{s.label}</div>
        </div>
      </div>
    ))}
    {extra}
  </div>
);

export default TinyStatStrip;
